import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const Add: React.FC<IIconProps> = ({
  size = IconSizes.md,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1993 5.00098C12.6288 5.00098 12.977 5.3492 12.977 5.77875V11.2232H18.4214C18.851 11.2232 19.1992 11.5714 19.1992 12.001C19.1992 12.4305 18.851 12.7788 18.4214 12.7788H12.977V18.2232C12.977 18.6528 12.6288 19.001 12.1993 19.001C11.7697 19.001 11.4215 18.6528 11.4215 18.2232V12.7788H5.977C5.54744 12.7788 5.19922 12.4305 5.19922 12.001C5.19922 11.5714 5.54744 11.2232 5.977 11.2232H11.4215V5.77875C11.4215 5.3492 11.7697 5.00098 12.1993 5.00098Z"
        fill="black"
      />
    </svg>
  );
};

export default Add;
